import { render } from "./ListeMotifSuiviPage.vue?vue&type=template&id=36f30c53&ts=true"
import script from "./ListeMotifSuiviPage.vue?vue&type=script&lang=ts"
export * from "./ListeMotifSuiviPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__